// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React, {type FC, memo, type MouseEvent} from 'react';
import {useHistory} from 'react-router-dom';

const NavLeftInIframeComp: FC = () => {
  const history = useHistory();
  return (
    <>
      <h1>Weights &amp; Biases</h1>
      <Icon
        className="nav"
        title="Go backward"
        onClick={(e: MouseEvent) => {
          e.preventDefault();
          history.goBack();
        }}
        name="chevron-back"
      />
      <Icon
        className="nav"
        title="Go forward"
        onClick={(e: MouseEvent) => {
          e.preventDefault();
          history.goForward();
        }}
        name="chevron-next"
      />
    </>
  );
};

const NavLeftInIframe = memo(NavLeftInIframeComp);

export default NavLeftInIframe;
